import React from 'react';
import { Strip } from '../../Models/Article';
import UnlimitedInkyMageImg from '../../Devon/Components/InkyMageImg/UnlimitedInkyMageImg';
import { Link } from '../../Devon/Components/InkyLink';
import { KodanshaColors } from '../../utils/constants';
import './HeroStrip.scss';

interface HeroStripProps {
    strip: Strip;
}

interface Params {
    hideInfoBlock: boolean;
    title: string;
    subTitle: string;
    authorName: string;
    buttonText: string;
    externalLink?: string;
    seriesReadableUrl?: string;
    seriesId?: number;
    url: string;
    colorOverlay?: string;
}

export function HeroStrip({ strip: { params } }: HeroStripProps) {
    const {
        hideInfoBlock,
        title,
        subTitle,
        authorName,
        buttonText,
        externalLink,
        seriesReadableUrl,
        seriesId,
        url,
        colorOverlay,
    } = params as Params;
    const thumbnail = (
        <UnlimitedInkyMageImg
            src={url}
            alt='Hero Banner'
            className='HeroStrip-image'
            preloadImage={true}
            sizes={[
                { width: 1000 },
                { width: 1400 },
                { width: 1600 },
                { width: 1800 },
                { width: 2000 },
            ]}
        />
    );

    let poster: React.ReactElement;
    let button: React.ReactElement | null = null;
    if (hideInfoBlock) {
        poster = <div className='HeroStrip-poster'>{thumbnail}</div>;
    } else if (externalLink) {
        poster = <a href={externalLink} className='HeroStrip-poster'>{thumbnail}</a>;
        button = <a href={externalLink}>{buttonText}</a>;
    } else {
        const to = `/series/${seriesReadableUrl ?? seriesId}`;
        poster = <Link to={to} className='HeroStrip-poster'>{thumbnail}</Link>;
        button = <Link to={to}>{buttonText}</Link>;
    }

    return (
        <div className={'HeroStrip' + (hideInfoBlock ? ' HeroStrip-withoutInfoBox' : ' HeroStrip-withInfoBox')}>
            <div className={'HeroStrip-posterWrapper' + (colorOverlay === 'grayscale' ? ' HeroStrip-posterWrapper-grayscale' : '')}>
                {poster}
                {colorOverlay && (
                    <div
                        className='HeroStrip-colorize'
                        style={{
                            backgroundColor: (KodanshaColors as Record<string, string | null>)[colorOverlay] ?? ''
                        }}
                    />
                )}
            </div>
            {!hideInfoBlock && (
                <div className='HeroStrip-infoBox'>
                    <h2>{subTitle}</h2>
                    <h1>{title}</h1>
                    <div className='HeroStrip-infoBox-footer'>
                        <div className='HeroStrip-authorName'>{authorName}</div>
                        {button}
                    </div>
                </div>
            )}
        </div>
    );
}
